import React, { useEffect, useState } from "react";
import { ILogin, IPermissionProps } from "../../models/Login";
import { EmptyFloatQuestion, IFloatQuestion, IModel } from "./FloatQuestionnaireMast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { Fetch } from "../../shared/Fetch";

interface IProps {
  setModal: (modal: IModel) => void;
  toast: any;
  reload: boolean;
  permissions: IPermissionProps;
}

export const Table = (props: IProps) => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  const DateFormat = loginObj.date_Format;

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <div className="my-2">
          <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
        </div>
      </React.Fragment>
    );
  };

  const openNew = () => {
    props.setModal({ open: true, singleData: EmptyFloatQuestion });
  };

  const loadFloatQus = async () => {
    try {
      setLoading(true);
      const response = await Fetch("Float/getQuestions", "GET", null, null, props.toast);
      if (response?.ok) {
        const data = await response.json();
        setTableData(data || []);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error(error);
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  const openEdit = (rowData: any) => {
    props.setModal({
      open: true,
      singleData: {
        ...rowData,
        answer_Type: rowData.answer_Type,
      },
    });
  };
  const action = (rowData: IFloatQuestion) => {
    return (
      <div className="flex gap-3">
        <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)} />
      </div>
    );
  };

  useEffect(() => {
    loadFloatQus();
  }, [props.reload]);

  return (
    <>
      <Toolbar left={leftToolbarTemplate} className="mb-3" />
      <DataTable value={tableData} loading={loading} showGridlines stripedRows header="Float Questionnaire">
        <Column field="question" header="Question" />
        <Column
          field="answer_Type"
          header="Answer Type"
          body={(rowData: IFloatQuestion) => {
            switch (rowData.answer_Type) {
              case 1:
                return "Yes/No";
              case 2:
                return "Text";
              case 3:
                return "Number";
              default:
                return "";
            }
          }}
        />
        <Column field="created_On" header="Created On" body={(rowData: any) => safeFormatDate(rowData.created_On, "dd/MM/yyyy", DateFormat, true)} />
        <Column field="created_By" header="Created By" />
        <Column field="additional_Question" header="Additional Question" body={(rowData: IFloatQuestion) => (rowData.additional_Question === true ? "Yes" : "No")} />
        <Column field="" header="Action" body={action} />
      </DataTable>
    </>
  );
};
